import React from 'react';
import { Link } from 'react-router-dom';
import './Sidebar.css';
import { HelpCircle, MessageSquare, Tags, Edit, Save } from 'lucide-react';

const Sidebar = () => {
  return (
    <div className="sidebar">
      <div className="section">
        <h3>Contribute</h3>
        <ul>
          <li>
            <Link to="/dashboard/ask-question">
              <HelpCircle className="icon" /> Ask a Question
            </Link>
          </li>
          <li>
            <Link to="/dashboard/my-questions">
              <MessageSquare className="icon" /> My Questions
            </Link>
          </li>
          <li>
            <Link to="/dashboard/my-replies">
              <Edit className="icon" /> My Replies
            </Link>
          </li>
          <li>
            <Link to="/dashboard/tags">
              <Tags className="icon" /> Tags
            </Link>
          </li>
          <li>
            <Link to="/dashboard/saved-draft">
              <Save className="icon" /> My Save Draft
            </Link>
          </li>
        </ul>
      </div>

      <div className="section">
        <h3>Sort by</h3>
        <select>
          <option value="">Sort by</option>
          <option value="Show All">Show All</option>
          <option value="Newest">Newest</option>
          <option value="Most Replies">Most Replies</option>
          <option value="Unanswered">Unanswered</option>
        </select>
      </div>

      <div className="section">
        <h3>Filter by Category</h3>
        <select>
          <option value="">All Categories</option>
          <option value="Django">Django</option>
          <option value="React">React</option>
          <option value="Web Development">Web Development</option>
          <option value="Data Science">Data Science</option>
          <option value="Machine Learning">Machine Learning</option>
          <option value="Cybersecurity">Cybersecurity</option>
          <option value="DevOps">DevOps</option>
          <option value="UI/UX Design">UI/UX Design</option>
          <option value="Mobile App Development">Mobile App Development</option>
        </select>
      </div>
    </div>
  );
};

export default Sidebar;
